import { Event } from "../../tracking";
import {
    CLOSE_ENROLL_DIALOG,
    ENROLL_TO_CLASS,
    LOADING_UI,
    LOAD_CHAT_GROUP,
    LOAD_CLASSES,
    LOAD_CLASS_SYLLABUS,
    LOAD_MILESTONES,
    LOAD_NOTIFICATIONS,
    LOAD_USER_CLASSES,
    SET_CLASS, UPDATE_DAY_CARD,
    UPDATE_NOTIFICATIONS_CARD,
    LOAD_AUTOPILOT_GROUP,
    GET_SURVEY_STATUS
} from '../types';

const initialState = {
    programs: [],
    programsUser: [],
    program: "",
    programId: "",
    syllabus: [],
    loading: false,
    isEnrollDialogOpen: false, // perhaps move this to uireducer
    notifications: [],
    groupLink: {},
    milestone: {},
    autopilot_group: "",
    survey_status: "",
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_CLASS:
            Event("Activity", "Get Syllabus From Programs", `${ action.payload }`);
            return {
                ...state,
                loading: false,
                programId: action.payload
            };
        case LOADING_UI:
            return {
                ...state,
                loading: true
            };
        case LOAD_CLASSES:
            return {
                ...state,
                programs: action.payload,
                loading: false
            };
        case LOAD_USER_CLASSES:
            Event("Activity", "Load User Classes", "");
            return {
                ...state,
                programsUser: action.payload,
                loading: false
            };
        case LOAD_CLASS_SYLLABUS:
            Event("Activity", "Check Syllabus", `${ action.programId }`);
            return {
                ...state,
                syllabus: action.payload.dayCards,
                programId: action.programId
            };
        case ENROLL_TO_CLASS:
            Event("Activity", "Enroll", `${ action.payload }`);

            return {
                ...state,
                programId: action.payload,
                loading: false,
                isEnrollDialogOpen: true
            }
        case UPDATE_DAY_CARD:
            const { dayId, taskNumber, isDone } = action.request
            let index = state.syllabus.findIndex(
                (dayCard) => dayCard.dayId === dayId
            )

            state.syllabus[index].status[taskNumber] = isDone;
            Event("Activity", "Update Day Card", `day:${ dayId };task:${ taskNumber };isDone:${ isDone }`);

            return {
                ...state
            };
        
        case UPDATE_NOTIFICATIONS_CARD: 
            const { isRead } = action.request
            state.notifications[action.request.dayId].isRead = isRead;
            Event("Notification", "Update Notification Card", `dayId:${ action.request.dayId };isRead:${ isRead }`);

            return {
                ...state
            };

        case CLOSE_ENROLL_DIALOG:
            return {
                ...state,
                isEnrollDialogOpen: false
            }
        case LOAD_NOTIFICATIONS: 
            return {
                ...state, 
                notifications: action.payload,
                loading: false
            }
        case LOAD_MILESTONES:
            return {
                ...state, 
                milestone: action.payload,
                loading: false
            }
        case LOAD_CHAT_GROUP: 
            return {
                ...state, 
                groupLink: action.payload,
                loading: false
            }

        case LOAD_AUTOPILOT_GROUP: 
            return {
                ...state, 
                autopilot_group: action.payload,
                loading: false
            };
        case GET_SURVEY_STATUS:
            return {
                ...state, 
                survey_status: action.payload,
                loading: false
            };
        default:
            return state;
    }
}